import React from "react";
import PropTypes from "prop-types";
import { deepmerge } from "@mui/utils";
import { CssBaseline, ThemeProvider as ThemeProviderMui } from "@mui/material";

import theme from "@/themes/default";

function ThemeProvider({ customTheme, children }) {
  return (
    <>
      <CssBaseline />
      <ThemeProviderMui theme={deepmerge(theme, customTheme)}>
        {children}
      </ThemeProviderMui>
    </>
  );
}

ThemeProvider.propTypes = {
  customTheme: PropTypes.object,
  children: PropTypes.node,
};

export default ThemeProvider;
